import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-light thead" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { class: "navbar-brand" }, "LCDS '19 League Website", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler me-3",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_5 = { class: "navbar-nav" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyLeaderboard = _resolveComponent("MyLeaderboard")!
  const _component_MyRoster = _resolveComponent("MyRoster")!
  const _component_MyRecords = _resolveComponent("MyRecords")!
  const _component_MyOpponents = _resolveComponent("MyOpponents")!

  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("nav", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", {
              href: "#",
              class: "nav-link px-3",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeComponent('Leaderboard'))),
              style: _normalizeStyle([_ctx.component === 'Leaderboard' ? {'text-decoration': 'underline'} : {'text-decoration': ''}])
            }, "Leaderboard", 4)
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createElementVNode("a", {
              href: "#",
              class: "nav-link px-3",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeComponent('Records'))),
              style: _normalizeStyle([_ctx.component === 'Records' ? {'text-decoration': 'underline'} : {'text-decoration': ''}])
            }, "Records", 4)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.component === 'Leaderboard')
        ? (_openBlock(), _createBlock(_component_MyLeaderboard, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.component === 'Rosters')
        ? (_openBlock(), _createBlock(_component_MyRoster, { key: 1 }))
        : _createCommentVNode("", true),
      (_ctx.component === 'Records')
        ? (_openBlock(), _createBlock(_component_MyRecords, { key: 2 }))
        : _createCommentVNode("", true),
      (_ctx.component === 'Opponents')
        ? (_openBlock(), _createBlock(_component_MyOpponents, { key: 3 }))
        : _createCommentVNode("", true)
    ])
  ]))
}